import * as React from "react";

function WrenchIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m55.52 18.37-3.35 3.36a7 7 0 1 1-9.9-9.9l3.36-3.36A14.51 14.51 0 0 0 42 8a14 14 0 0 0-13.19 18.7L10.34 42.34a8 8 0 0 0 11.32 11.32L37.3 35.19a14 14 0 0 0 18.22-16.82z"
  }));
}

export default WrenchIcon;